/** @format */

export interface ReviewAISummaryResponse {
  detail: string;
  disclaimer: string;
  status: number;
  summary: string;
  title: string;
  type: string;
}
